export const PLANNER_INDEX = 'PLANNER_INDEX'
export const PLANNER_LOADING = 'PLANNER_LOADING'



// WEBPACK FOOTER //
// ./src/store/actions/planner.js